import React from 'react';
import './About.css'

const About = () => {
  return (
    <div>

      <div className='bg-secondary text-white'>
        <h1>Contact us</h1>
        <h3>Name :Md. Obaidur Rahman</h3>
        <h3>phone number:01612897800</h3>

      </div>



    </div>
  );
};

export default About;